import { render, staticRenderFns } from "./ReferralAgents.vue?vue&type=template&id=255660b6"
import script from "./ReferralAgents.vue?vue&type=script&lang=js"
export * from "./ReferralAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports